<div class="docs-section">
  <div class="docs-section__head">
    <h1 class="docs-h1">API Reference</h1>
    <p class="docs-subtitle">{{ endpoints.length }} endpoints · {{ schemaCount }} schemas</p>
  </div>
  <div class="docs-ep-list">
    @for (ep of endpoints; track ep.id) {
      <a class="docs-ep-card docs-ep-card--post" [routerLink]="ep.id">
        <span class="endpoint-badge endpoint-badge--post">POST</span>
        <span class="docs-ep-card__path">{{ ep.path }}</span>
        <span class="docs-ep-card__spacer"></span>
        <span class="docs-ep-card__arrow">&rarr;</span>
      </a>
    }
  </div>
  <p class="docs-subtitle">
    Documentation only: nothing validates or coerces an upstream payload, and bodies are relayed untouched. A
    field marked nullable appears only when the include_* flag that produces it was set.
  </p>
</div>
